import { defineMessages, useIntl } from 'react-intl';
import styles from '../styles.module.css';

const ErrorPage = () => {
  const intl = useIntl();
  return (
    <div className={styles.errorPage}>
      <p>{intl.formatMessage(messages.error_page_message)}</p>
      <p>{intl.formatMessage(messages.error_page_instructions)}</p>
    </div>
  );
};

export default ErrorPage;

const messages = defineMessages({
  error_page_message: {
    id: 'error_page_message',
    defaultMessage: 'There has been an issue while submitting your form.',
  },
  error_page_instructions: {
    id: 'error_page_instructions',
    defaultMessage:
      'Please try refreshing the page and submitting it again or contact the site administrators.',
  },
});
